import React from "react";

const STEPS = [
  { icon: "bi-infinity", label: "One Premium Package", sub: "Unified Subscription" },
  { icon: "bi-grid-1x2", label: "SELECTEZI Platform", sub: "Infrastructure Access" },
  { icon: "bi-shop-window", label: "Business Showcase", sub: "Verified Presence" },
  { icon: "bi-speedometer2", label: "Marketing Agent", sub: "Included Service", highlight: true },
  { icon: "bi-graph-up-arrow", label: "Promotional Activity", sub: "Continuous Output", highlight: true },
];

export default function PremiumPackage() {
  return (
    <section className="section-py section-soft">
      <div className="container-selectezi">
        <div className="premium-panel">
          <span className="eyebrow-badge">
            <i className="bi bi-asterisk" style={{ fontSize: 11 }} />
            Premium Value
          </span>

          <h2 className="section-title mt-4" >
            One Premium Package More Than Platform Access
          </h2>
          <p className="section-subtitle-new">
            There is no separate payment required to hire a SELECTEZI
            Marketing Agent when the Marketing Agent service is included in
            the selected Premium monthly or yearly package.
          </p>

          <div className="premium-steps">
            <div className="row g-4 text-center">
              {STEPS.map((step) => (
                <div className="col-6 col-md" key={step.label}>
                  <div className={`premium-step-icon${step.highlight ? " is-highlight" : ""}`}>
                    <i className={`bi ${step.icon}`} />
                  </div>
                  <div className={`premium-step-label${step.highlight ? " is-highlight" : ""}`}>
                    {step.label}
                  </div>
                  <div className="premium-step-sub">{step.sub}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="info-banner">
            <i className="bi bi-info-circle-fill" />
            <span>
              The exact features and level of promotion depend on the
              Premium package selected
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
